<template>
  <div class="container" style="padding-top: 11em; padding-bottom: 27em">
    <NotifyItem v-for="(item, index) in dataList"
                  @click="onNotifyClick(index)"
                  @longClick="onNotifyLongClick(index)"
                  :item="item"
                style="margin-left: 1em; margin-right: 1em;"
    >
    </NotifyItem>
    <NotifyDetailPopup
      :visible.sync="showDetail"
      :item="notifySelected"
    >
    </NotifyDetailPopup>
  </div>
</template>
<script>
import Utils from "../../../../config/utils";
import NotifyItem from "../../../controls/NotifyItem";
import NotifyDetailPopup from "../../../controls/popup/NotifyDetailPopup";

export default {
  name: "AdminWriteNotice",
  components:{
    NotifyItem,
    NotifyDetailPopup,
  },
  data() {
    return {
      dataList:[],
      notifySelected:null,
      currentPage:1,
      pageLimit:0,
      showDetail:false,
    }
  },
  props:["keyword","pageCnt","phone","searchType"],
  methods:{
    getList() {
      Utils.requestGet(this.$c.API.Notify.findNotifyList, {
        page_num: this.currentPage,
        column: this.searchType,
        keyword: this.keyword,
        phone: this.phone,
      }).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.dataList = result.data.list.map(it => {
            it.f_select = false;
            return it;
          });
          this.loadingEnd = result.data.limit > result.data.list.length;
          this.$emit('update:pageCnt',result.data.count);
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onNotifyClick(index) {
      if (this.dataList.some(it => {
        return it.f_select;
      })) {
        // there is selected cell by long click
        this.dataList = this.dataList.map((it, idx) => {
          if (index == idx) {
            it.f_select = !it.f_select;
          }
          return it;
        });
        return;
      }

      this.notifySelected = this.dataList[index];
      this.showDetail = true;
    },

    onNotifyLongClick(index){
      this.dataList = this.dataList.map((it, idx) => {
        if (index == idx) {
          it.f_select = true;
        }
        return it;
      });
    },
  },

  mounted() {
    this.getList();
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
@import '../../../../assets/css/_vars.scss';
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminWriteNotice.vue